export const MIN_MONEY_AMOUNT = 5;
export const MAX_MONEY_AMOUNT = 995;
export const MONEY_STEP = 20;
